import { ticketGroupTableContants } from '../constants';
import { SELECTED_ALL_VALUES } from '../constants/ticket-group-table.contants';
import { selectedStatusTicketGroupSelector } from '../selectors/workdesk-tickets.selector';

const _setSelectedId = (id: string, value: boolean) => {
  return {
    type: ticketGroupTableContants.SET_SELECTED_ID,
    payload: {
      id,
      value,
    },
  };
};

const setSelectedId = (id: string, value: boolean) => {
  return (dispatch, getState) => {
    const selectedAll = getState().ticketGroupTable.selectedAll;
    if (!value && selectedAll === 'ALL') {
      dispatch(_setSelectedAll('SOME'));
    }
    dispatch(_setSelectedId(id, value));
  };
};

const bulkSetSelectedIds = (ids: string[], value: boolean) => {
  return {
    type: ticketGroupTableContants.BULK_SET_SELECTED_ID,
    payload: { ids, value },
  };
};

const clearSelectedId = () => {
  return {
    type: ticketGroupTableContants.CLEAR_SELECTED_ID,
  };
};

const _setSelectedAll = (value: SELECTED_ALL_VALUES) => {
  return {
    type: ticketGroupTableContants.SET_SELECTED_ALL,
    payload: {
      value,
    },
  };
};

/**
 * from select all checkbox
 * @param value
 */
const setSelectedAll = (value: 'ALL' | 'NONE') => {
  return (dispatch, getState) => {
    dispatch(_setSelectedAll(value));
    if (value === 'ALL') {
      const selectedStatusTicketGroup = selectedStatusTicketGroupSelector(
        getState(),
      );

      console.debug(
        `selectedStatusTicketGroup: `,
        selectedStatusTicketGroup,
      );

      if (!selectedStatusTicketGroup) {
        console.error(
          'something must be wrong. no status is selected',
        );
      } else {
        const { ticketIds } = selectedStatusTicketGroup;
        dispatch(bulkSetSelectedIds(ticketIds, true));
      }
    } else if (value === 'NONE') {
      dispatch(clearSelectedId());
    }
  };
};

const resetTicketGroupTableState = () => {
  return {
    type: ticketGroupTableContants.RESET_STATE,
  };
};

export const ticketGroupTableActions = {
  setSelectedId,
  bulkSetSelectedIds,
  clearSelectedId,
  //   _setSelectedAll,
  setSelectedAll,
  resetTicketGroupTableState,
};
